import { gql } from '@apollo/client';

export const CLAIM_REWARD_API_CORE_MUTATION = gql`
  mutation ClaimReward($data: ClaimRewardInput!) {
    claimReward(data: $data)
  }
`;
